import { render, staticRenderFns } from "./modalMensagemHome.vue?vue&type=template&id=56be3f2f"
import script from "./modalMensagemHome.vue?vue&type=script&lang=js"
export * from "./modalMensagemHome.vue?vue&type=script&lang=js"
import style0 from "./modalMensagemHome.vue?vue&type=style&index=0&id=56be3f2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports